import { t } from '$i18n'
// Logic
import { useHall } from '$logic/hall/react-hook'
import { showCopyMenu } from '$comp/modals/menus/copy-menu'
import {
  showLinkSavedInMemorySnackbar,
  showTextSavedInMemorySnackbar,
} from '$comp/snackbars'
import { ProfileInfoParser } from '$common/profile-info-parser'
import { getHallPublicLink } from '$func/hall'
// Common
import { ProfileInfoItem } from '../profile-info-item'
import { useIsClientUserSupport } from '$logic/client-user'
import { SHOW_USER_INFO_TO_SUPPORT } from '$func/environmentInfo'

interface Props {
  hallId: string
}

export function HallProfileInfo({ hallId }: Props) {
  const { entity: hall } = useHall(hallId)
  const { description, identifier } = hall || {}
  const isClientUserSupport = useIsClientUserSupport()

  if (!(description || identifier)) return null

  const hallPublicLink = getHallPublicLink(hall)

  const showHallInfo = isClientUserSupport && SHOW_USER_INFO_TO_SUPPORT

  return (
    <>
      {description && (
        <ProfileInfoParser
          value={description}
          label={t('profile.hall.description')}
          onClick={() =>
            showCopyMenu({
              text: description,
              onDone: showTextSavedInMemorySnackbar,
            })
          }
        />
      )}

      {showHallInfo && (
        <ProfileInfoItem
          onClick={() => {
            showCopyMenu({
              text: hallId,
              onDone: showTextSavedInMemorySnackbar,
            })
          }}
          label={t('user.id')}
          value={hallId}
        />
      )}

      {identifier && hall?.public && (
        <ProfileInfoItem
          value={hallPublicLink}
          label={t('profile.hall.inviteLink')}
          onClick={() =>
            showCopyMenu({
              text: hallPublicLink || '',
              onDone: showLinkSavedInMemorySnackbar,
            })
          }
        />
      )}
    </>
  )
}
